export default "__VITE_ASSET__DNR1Bx4o__"